export const LOCALE_MAP = {
    en: 'en-US',
    de: 'de-DE',
    fr: 'fr-FR',
    es: 'es',
    pt: 'pt-BR',
    it: 'it-IT',
    nl: 'nl-NL',
} as const;

export const LEGACY_MAP = {
    iw: 'he', // Old Hebrew -> New Hebrew
    jy: 'yi', // Old Yidish -> New Yidish
    fil: 'tl', // Filipino -> Tagalog (Filipino)
    ceb: 'tl', // Cebuano -> Tagalog (Filipino)
    hmn: 'za', // Hmong -> Chuang (Zhuang - Chinese dialect)
    haw: 'en', // Hawaiian -> English,
} as const;
